import { render, staticRenderFns } from "./SafetyObservationItemCorrectionForm.vue?vue&type=template&id=3ab4b503&"
import script from "./SafetyObservationItemCorrectionForm.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationItemCorrectionForm.vue?vue&type=script&lang=js&"
import style0 from "./SafetyObservationItemCorrectionForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports